import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/hero/hero_eth.svg'
import _imports_1 from '../assets/hero/hero_polis.svg'
import _imports_2 from '../assets/hero/hero_text.svg'
import _imports_3 from '../assets/hero/hero_prague.svg'


const _withScopeId = n => (_pushScopeId("data-v-7ad012ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero" }
const _hoisted_2 = { class: "hero__image-desktop" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hero__image-eth",
  src: _imports_0
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hero__image-polis",
  src: _imports_1
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hero__image-text",
  src: _imports_2
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "hero__image-prague",
  src: _imports_3
}, null, -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<span id=\"liveStream\" data-v-7ad012ea></span><div class=\"hero__event-date\" data-v-7ad012ea><div class=\"hero__event-date-marquee-block\" data-v-7ad012ea><div class=\"hero__event-date-marquee-inner to-right\" data-v-7ad012ea><span data-v-7ad012ea><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div></span><span data-v-7ad012ea><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div><div class=\"hero__event-date-marquee-item\" data-v-7ad012ea> ETH Prague   June 10th — 12th   </div></span></div></div><div class=\"hero__event-date-text-mobile\" data-v-7ad012ea> ETH Prague <br data-v-7ad012ea> June 10th — 12th </div></div>", 2)

import useHero, { selectedLiveStream, LiveStreamProvider } from "./useHero";
import { onMounted, ref } from "vue";
import videojs from 'video.js'
import 'video.js/dist/video-js.min.css';
import 'video.js/dist/video.min.js';
// import 'videojs-youtube/dist/Youtube.min.js';
import 'videojs-contrib-quality-levels'
import 'videojs-hls-quality-selector'


enum DeviceType {
  MOBIL = "mobile",
  DESKTOP = "desktop",
}

const LINK_TO_YOUTUBE_STREAM = "https://www.youtube.com/embed/31SV969GXaA" // 12.6.


// const LINK_TO_LIVEPEER_STREAM = "https://livepeercdn.com/recordings/6bee1366-1c1d-43d2-9f62-01eb11946672/index.m3u8"; // test

const LINK_TO_LIVEPEER_STREAM = "https://livepeercdn.com/hls/2ed3nqwq5id2oadm/index.m3u8" // real livestream


export default /*#__PURE__*/_defineComponent({
  __name: 'Hero',
  setup(__props) {

const {LPVideoPlayer, YTVideoPlayer} = useHero()
// const LINK_TO_YOUTUBE_STREAM = "https://www.youtube.com/embed/HHi8qOtHnhE"; //demo

// const LINK_TO_YOUTUBE_STREAM = "https://www.youtube.com/embed/kFZP9J9yo-0" // 10.6.
// const LINK_TO_YOUTUBE_STREAM = "https://www.youtube.com/embed/Fd0HjhZayt4" // 11.6.
const stripe = "ETH Prague \u00A0  June 10th — 12th \u00A0".repeat(3);

const selectStreamProvider = (provider: LiveStreamProvider) => {
  selectedLiveStream.value = provider;
  if (provider == "Youtube" ) {
    YTVideoPlayer.value.player.play();
  } else {
    LPVideoPlayer.value.player.play();
    LPVideoPlayer.value.getElementsByTagName("video")[0].style.display = "block";
  }
};

const getHeroImage = (forDevice: string) => {
  const randomHeroNum = Math.floor(Math.random() * 4) + 1;
  switch (forDevice) {
    case DeviceType.MOBIL:
      return require(`../assets/hero/hero_mobile_${randomHeroNum}.webp`);
    case DeviceType.DESKTOP:
      return require(`../assets/hero/hero_${randomHeroNum}.webp`);
  }
};

onMounted( async () => {
  const livepeer = LPVideoPlayer.value;
  
  videojs(livepeer, {
      fill: true,
      responsive: true,
      controlBar:{
        pictureInPictureToggle: true,
      },
      sources: [
      {
        src: LINK_TO_LIVEPEER_STREAM,
        type: 'application/x-mpegURL'
      }],
    })

    livepeer.player.hlsQualitySelector({
      displayCurrentQuality: true,
    });
    
    var img = livepeer.player.controlBar.addChild('Component', {}, 3); // 3rd arg is index, i.e. first
    img.addClass("livepeer-logo");
    img.el_.setAttribute("style",'background:url("https://streameth.tv/_next/image?url=%2Flivepeer_logo_dark.png&w=96&q=75");width: 100px;padding: 3px;filter: invert(1);')
    img.el_.setAttribute("onclick",'window.open("https://livepeer.org/", "_blank")');

    const youtube = YTVideoPlayer.value;
    videojs(youtube, {
      fill: true,
      responsive: true,
      sources: [
      {
        src: LINK_TO_YOUTUBE_STREAM,
        type: "video/youtube"
      }]
    })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("img", {
          class: "hero__image-main-image",
          src: getHeroImage(DeviceType.DESKTOP)
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("img", {
        class: "hero__image-mobile",
        src: getHeroImage(DeviceType.MOBIL),
        alt: "hero"
      }, null, 8, _hoisted_8)
    ]),
    _hoisted_9
  ], 64))
}
}

})